import { Compass } from "lucide-react";
import { useTranslate } from "ra-core";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { useMiRol } from "../datos/useMiRol";
import {
  abrirGuia,
  cerrarGuia,
  guiaVista,
  marcarGuiaVista,
  useGuiaAbierta,
} from "./estado";
import { ofrecerAlEntrar, papelDe, PASOS_GUIA } from "./pasos";
import { RecorridoGuiado } from "./RecorridoGuiado";

/**
 * Donde vive la guía (va en los dos layouts): la bienvenida del primer día para setters y
 * consultores («¿Te enseñamos cómo funciona?») y el recorrido, se abra desde donde se abra.
 */
export const GuiaHost = () => {
  const translate = useTranslate();
  const abierta = useGuiaAbierta();
  const rol = useMiRol();
  const [bienvenida, setBienvenida] = useState(false);
  const cargado =
    rol.id != null && (rol.esAdmin || rol.vende || rol.esConsultor);

  useEffect(() => {
    if (!cargado || rol.esAdmin || rol.id == null) return;
    let vivo = true;
    void guiaVista(rol.id).then((vista) => {
      if (
        vivo &&
        ofrecerAlEntrar({
          esAdmin: rol.esAdmin,
          cargado,
          vista,
          automatizado: navigator.webdriver === true,
        })
      )
        setBienvenida(true);
    });
    return () => {
      vivo = false;
    };
  }, [cargado, rol.esAdmin, rol.id]);

  const responder = (ver: boolean) => {
    setBienvenida(false);
    if (rol.id != null) void marcarGuiaVista(rol.id);
    if (ver) abrirGuia(papelDe(rol));
  };

  return (
    <>
      <Dialog open={bienvenida} onOpenChange={(a) => !a && responder(false)}>
        <DialogContent className="sm:max-w-md" data-testid="guia-bienvenida">
          <DialogHeader>
            <span className="mb-2 flex size-10 items-center justify-center rounded-xl bg-[var(--serie-llamadas)]/10 text-[var(--serie-llamadas)]">
              <Compass className="size-5" aria-hidden />
            </span>
            <DialogTitle className="titulo-seccion text-xl">
              {translate("nevora.guia.bienvenida.titulo")}
            </DialogTitle>
            <DialogDescription>
              {translate(`nevora.guia.bienvenida.texto_${papelDe(rol)}`)}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => responder(false)}>
              {translate("nevora.guia.bienvenida.ahora_no")}
            </Button>
            <Button onClick={() => responder(true)}>
              {translate("nevora.guia.ver")}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      {abierta ? (
        <RecorridoGuiado
          key={abierta}
          papel={abierta}
          pasos={PASOS_GUIA[abierta]}
          alCerrar={() => cerrarGuia()}
        />
      ) : null}
    </>
  );
};
